module.exports = __webpack_public_path__ + "static/media/g2Review1.fbfe0488.png";